import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../../styles/org-buttons.css";
import { buttonText } from "../../utils/buttonText";

function CVATCreateProjectModal({ show, onHide, onCreate, creating }) {
  const [projectName, setProjectName] = useState("");

  const handleCreate = () => {
    if (!projectName.trim()) {
      window.alert("Please input project name");
      return;
    }
    onCreate(projectName.trim(), () => setProjectName(""));
  };

  const handleClose = () => {
    setProjectName("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton closeLabel={buttonText("Close")}>
        <Modal.Title>Create CVAT Project</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          type="text"
          className="form-control"
          placeholder="Project Name"
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          autoFocus
        />
        <small className="text-muted" style={{ display: "block", marginTop: 8 }}>
          Labels are synced from FiftyOne fields when you upload datasets.
        </small>
      </Modal.Body>
      <Modal.Footer className="org-modal-footer">
        <button type="button" className="org-btn org-btn-secondary" onClick={handleClose}>
          {buttonText("Cancel")}
        </button>
        <button type="button" className="org-btn org-btn-primary" onClick={handleCreate} disabled={creating}>
          {buttonText(creating ? "Creating..." : "Create")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CVATCreateProjectModal;
